define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/xml"
], function(declare,domClass,query,stateColorResolver,html,StateWidget,locale,xml) {

return declare(StateWidget, {
		_processHtml: function(/*Context*/ctx, /*DOMNode*/dom) {
			// summary: process each element with a key according to its matching definition
			this.inherited(arguments);
			
			var node = ctx.getNode();
			var eDraft = query(".draft", dom)[0];
			var eMarkets = query(".markets", dom)[0];
			var eCustomers = query(".customers", dom)[0];
			var eNotAvailable = query(".notavailable", dom)[0];
			
			const css = stateColorResolver.getStateCss(node);
			const stateEnumValue = xml.enumGetText(node.State);
			
			switch (stateEnumValue) {
				case "Draft":  domClass.add(eDraft, css); break;
				case "ReleaseToMarkets": domClass.add(eMarkets, css); break;
				case "ReleaseToCustomers": domClass.add(eCustomers, css); break;
				case "NotAvailable": domClass.add(eNotAvailable, css); break;
			}

			html.text(eDraft, locale.getEnumName("MCState:Draft", true));
			html.text(eMarkets, locale.getEnumName("MCState:ReleaseToMarkets", true));
			html.text(eCustomers, locale.getEnumName("MCState:ReleaseToCustomers", true));
			html.text(eNotAvailable, locale.getEnumName("MCState:NotAvailable", true));
		}
	});
});